export default "__VITE_ASSET__38968bdc__"